import { Fragment } from "react";
import BackButton from "../BackButton";
import { getLabel } from "../../hooks/use-labels";
import HexPageTitle from "../HexPageTitle";
import { GetLocationState } from "../../utils/common-utils";
import { useNavigate } from "react-router-dom";

const LinkPageHeader = ({ pageTitle, onBack, backLabel, className }) => {
  const navigate = useNavigate();

  const { link } = GetLocationState() || { link: "" };

  const goBack = () => {
    onBack && onBack();
    navigate(link.path, {
      ...(link.previousState && { state: link.previousState }),
    });
  };

  return (
    <Fragment>
      {link && (
        <BackButton
          onClick={goBack}
          text={backLabel || getLabel("backLabel")}
          className="mb-40"
        />
      )}
      <HexPageTitle title={pageTitle} className={className || ""} />
    </Fragment>
  );
};

export default LinkPageHeader;
